var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.99401C22.0005 8.20621 21.8456 7.42605 21.5442 6.69819C21.2428 5.97034 20.8008 5.30909 20.2435 4.75231C19.6861 4.19553 19.0244 3.75416 18.2963 3.45348C17.5681 3.15279 16.7878 2.99869 16 3.00001H8C4.687 3.00001 2 5.69501 2 8.99401V21H16C19.313 21 22 18.305 22 15.006V8.99401ZM10 11V13H8V11H10ZM16 11V13H14V11H16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f1852cb9607a27b306681b38983cea27.svg";
export { ForwardRef as ReactComponent };